import { useEffect, useState } from 'react';
import '../styles/Settings.css'; // Reuse existing styles
import RelativeSvgLoader from '../common/components/RelativeSvgLoader';
import YesNoPopup from '../common/components/YesNoPopup'; // Import the popup component
import AuthData from '../common/AuthData';
import Fetch  from '../services/fetchService';
import Post from '../services/postService';
import Success from  '../common/components/SuccessMessage'
import { SETTINGS_API } from '../common/ResourcePaths'; // Import the constant
import { FaExclamationCircle } from 'react-icons/fa'; // Import exclamation icon

// Utility function to encode an address
const encodeAddress = (address) => {
    return encodeURIComponent(address.trim());
};

function Location() {
    const [address, setAddress] = useState('');
    const [mapLink, setMapLink] = useState('');
    const [apiKey, setApiKey] = useState('');
    const [showPopup, setShowPopup] = useState(false);
    const [loader, setLoader] = useState(false);
    const [modified, setModified] = useState(false);
    const [successTimer, setSuccessTimer] = useState(10);
    const [success, setSuccess] = useState(false);
    const [uri, setUri] = useState('');
    const [disabled, setDisabled] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);

    const preview = () => {
        const newUri = createMapUri(uri, address, apiKey);
        setMapLink(newUri);
    }

    const createMapUri = (uri, address, apiKey) => {
        const encodedAddress = encodeAddress(address);
        let mapUri = uri;
        mapUri = mapUri
        // eslint-disable-next-line
            .replaceAll('${encodedAddress}', encodedAddress)
              // eslint-disable-next-line
            .replaceAll('${apiKey}', apiKey);

        return mapUri;
    }

    useEffect(() => {
        const getMapsLocation = async () => {
            try {
                setLoader(true);
                const authData = AuthData.getAuthData();
                const url = `${authData.appFunctionUrl}${SETTINGS_API}/map?code=${authData.azureFunctionKey}`;
                const response = await Fetch(url, authData.clientId);
                const address = response.address;
                setAddress(response.address);
                setDisabled(response.disabled || false);

                let mapUri = response.uri;
                setApiKey(response.apiKey);
                setUri(response.uri);
                mapUri  = createMapUri(mapUri,address, response.apiKey);

                setMapLink(mapUri);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoader(false);
            }
        };

        getMapsLocation();
    }, []);

    const handleSave = async () => {
        try {
            setLoader(true);
            const authData = AuthData.getAuthData();
            const url = `${authData.appFunctionUrl}${SETTINGS_API}/location?code=${authData.azureFunctionKey}`;
            const data = {
                address: address,
                disabled: disabled,
                apiKey: apiKey,
                uri: uri
            };
            
            const response = await Post(url, authData.clientId, data);
            let mapUri = response.uri;
            mapUri = createMapUri(mapUri, response.address, response.apiKey);

            setMapLink(mapUri);
            setAddress(response.address); 
            setDisabled(response.disabled || false);
            setSuccess(true);
            setSuccessTimer(10);
            
            const timerInterval = setInterval(() => {
                setSuccessTimer((prev) => {
                    if (prev <= 1) {
                        clearInterval(timerInterval);
                        setSuccess(false);
                    }
                    return prev - 1;
                });
            }, 1000);
        } catch (error) {
            console.error("Error saving location:", error);
        } finally {
            setLoader(false);
        }
    };

    const handleYes = () => {
        setShowPopup(false);
        reset();
    };

    const handleNo = () => {
        setShowPopup(false);
    };

    const reset = () => {
        setAddress('');
        setMapLink('');
        setDisabled(false);
        setModified(true);
    };

    const handleLocationDisabledChange = (e) => {
        setDisabled(e.target.checked);
        setModified(true);
    };

    return (
        <div className="container" style={{ position: 'relative' }}>
            {loader && <RelativeSvgLoader />}
            <div className="form-wrapper" style={{ opacity: loader ? 0.3 : 1 }}>
                {success && (
                    <Success
                        message={`Data saved successfully! (${successTimer}s)`}
                    />
                )}
                    <div style={{display: 'flex', justifyContent: 'flex-end', marginBottom: '15px'}}>
                        <label style={{display: 'flex', alignItems: 'center', gap: '8px', fontSize: '0.9rem', fontWeight: 'bold'}}>
                            <input
                                type="checkbox"
                                checked={disabled}
                                onChange={handleLocationDisabledChange}
                            />
                            Disable
                            <div style={{position: 'relative', display: 'inline-block'}}>
                                <FaExclamationCircle
                                    style={{
                                        color: '#28a745',
                                        fontSize: '14px',
                                        marginLeft: '4px',
                                        cursor: 'help'
                                    }}
                                    onMouseEnter={() => setShowTooltip(true)}
                                    onMouseLeave={() => setShowTooltip(false)}
                                />
                                {showTooltip && (
                                    <div style={{
                                        position: 'absolute',
                                        bottom: '20px',
                                        right: '0',
                                        backgroundColor: '#28a745',
                                        color: 'white',
                                        padding: '8px 12px',
                                        borderRadius: '4px',
                                        fontSize: '12px',
                                        whiteSpace: 'nowrap',
                                        zIndex: 1000,
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
                                    }}>
                                        When checked, hides location information from customers
                                        <div style={{
                                            position: 'absolute',
                                            top: '100%',
                                            right: '10px',
                                            width: 0,
                                            height: 0,
                                            borderLeft: '5px solid transparent',
                                            borderRight: '5px solid transparent',
                                            borderTop: '5px solid #28a745'
                                        }}></div>
                                    </div>
                                )}
                            </div>
                        </label>
                    </div>
                    <form
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleSave();
                        }}
                    >
                        <div className="form-group">
                            <input
                                type="text"
                                placeholder="Enter Address"
                                value={address}
                                readOnly={disabled}
                                onChange={(e) => {
                                    setAddress(e.target.value);
                                    setModified(true);
                                }}
                                className="input-field"
                            />
                        </div>
                        <div className="form-footer">
                            <button
                                type="submit"
                                disabled={!modified}
                                className="submit-button">
                                Save
                            </button>
                            <button
                                type="button"
                                className="preview-button"
                                onClick={() => preview()}
                                style={{ marginLeft: '10px' }}>
                                Preview
                            </button>
                            <button
                                type="button"
                                className="clear-data-button"
                                style={{ marginLeft: '10px' }}
                                onClick={() => setShowPopup(true)}>
                                Reset
                            </button>
                        </div>
                    </form>
                    {mapLink && (
                        <div className="map-preview" style={{ 
                            marginTop: '30px', 
                            marginBottom: '30px',
                            padding: '20px',
                            backgroundColor: '#ffffff',
                            borderRadius: '16px',
                            boxShadow: '0 8px 20px rgba(0, 0, 0, 0.08)',
                            border: '1px solid rgba(229, 231, 235, 0.6)'
                        }}>
                            <img
                                src={mapLink}
                                alt={`Map of ${address}`}
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    maxHeight: '400px',
                                    objectFit: 'contain',
                                    border: '2px solid rgba(229, 231, 235, 0.6)',
                                    borderRadius: '12px',
                                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                                    display: 'block'
                                }}
                            />
                        </div>
                    )}
                    {showPopup && (
                        <YesNoPopup handleYes={handleYes} handleNo={handleNo} />
                    )}
                </div>
        </div>
    );
}

export default Location;